/* eslint-disable no-unused-vars */
export enum FilterOption {
  MY_TEAM = 'MY_TEAM',
  ALL_COMPANY = 'ALL_COMPANY',
}
